import { render } from "./ImplantationAssetIndexComponent.vue?vue&type=template&id=220ab1f4"
import script from "./ImplantationAssetIndexComponent.vue?vue&type=script&lang=js"
export * from "./ImplantationAssetIndexComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__